<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import "./assets/js/zepto_yl.min.js";
import * as URL from './assets/js/url.js';
(function(doc, win) { // rem 自适应
    var defaulfFontSize = '85.3333333px';
    var docEl = doc.documentElement,
        // docEl.style.fontSize = defaulfFontSize + 'px';
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function() {
            var clientWidth = docEl.clientWidth;
            if (!clientWidth) return;
            if (clientWidth > 640) {
                docEl.style.fontSize = defaulfFontSize;
            } else {
                docEl.style.fontSize = 100 * (clientWidth / 750) + 'px';
            }
        };
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);
export default {
  name: 'App',
  data(){
    return {
      storeId: 'null',
      isYlxd: false,
      isuleApp: false,
    }
  },
  mounted(){
    //Start 是否APP打开页面
    
    //End 是否APP打开页面
  },
  created(){

  },
  methods:{
    GetQueryString: function(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    },
  },
  components:{
    
  }
}
</script>

<style>
@import "./assets/css/style.css";
</style>



// WEBPACK FOOTER //
// src/App.vue